export const exchangeOptions = [
  "Bybit https://www.bybit.com/ SG",
  "Binance https://www.binance.com/ CN",
  "CRYPTOTECH https://www.cryptotechdev.com/ BR",
  "Huobi https://www.htx.com/ CN",
  "Kucoin https://www.kucoin.com/ SC",
  "Bitget https://www.bitget.com/ SC",
  "MEXC https://www.mexc.com/ SC",
  "BingX https://www.bingx.com/ AU",
  "Gate.IO https://www.gate.io/ AE",
];

export const assetsOptions = ["BTC", "USDT", "BNB", "ETH", "USDC", "DOGE", "BRL"];

export const blockchainsOptions = [
  "Ethereum (ERC20)",
  "BSC (BEP20)",
  "Bitcoin (BTC)",
  "Solana (SOL)",
  "TON",
  "TRC20",
  "Near (NEAR)",
  "Avalanche (AVAX)",
];

export const paymentOptions = [
  "Pix",
  "Transferência Bancária",
  "Dinheiro",
  "Cartão de Crédito",
  "Cartão de Débito",
];

export const limitDateOptions = ["1", "2", "4", "8", "12", "18", "24", "48", "72"];

export const walletOptions = [
  "Metamask",
  "Trust Wallet",
  "SafePal",
  "Exodus",
  "Electrum",
  "CoinBase Wallet",
  "Trezor",
  "Ledger",
  "Bitpay",
  "Bybit",
  "Binance",
  "Gate.IO",
  "Kucoin",
  "Huobi",
];

export const estadoCivilOptions = ["Solteiro", "Casado", "Separado", "Divorciado", "Viúvo"];
